import React, { useEffect, useState, useRef } from 'react';
import { UploadIcon, CheckCircleIcon, ClockIcon, MailIcon, RefreshCwIcon, DownloadIcon, XIcon, UsersIcon, UserCheckIcon, ShieldCheckIcon, AlertCircleIcon, TrendingUpIcon } from 'lucide-react';
interface Supplier {
  id: string;
  name: string;
  email: string;
  paymentTerms: string;
  inviteSent: boolean;
  status: 'invited' | 'pending' | 'active';
  lastActivity: string;
  fundingActivity: string;
  source?: 'seed' | 'csv' | 'erp';
}
// Seeded suppliers - 12 invited (2 active, 3 pending, 7 invited)
const SEEDED_ACTIVATED_SUPPLIERS: Supplier[] = [{
  id: 'seed-001',
  name: 'Premium Textiles Inc',
  email: 'ap@premiumtextiles.com',
  paymentTerms: 'Net 60',
  inviteSent: true,
  status: 'active',
  lastActivity: '2025-01-15',
  fundingActivity: 'Accepted 2 offers this week',
  source: 'seed'
}, {
  id: 'seed-002',
  name: 'Global Apparel Wholesale',
  email: 'billing@globalapparel.com',
  paymentTerms: 'Net 45',
  inviteSent: true,
  status: 'active',
  lastActivity: '2025-01-14',
  fundingActivity: 'Consistent usage',
  source: 'seed'
}, {
  id: 'seed-003',
  name: 'Fashion Forward Distributors',
  email: 'accounts@fashionforward.com',
  paymentTerms: 'Net 30',
  inviteSent: true,
  status: 'pending',
  lastActivity: '2025-01-14',
  fundingActivity: 'Accepted initial advance',
  source: 'seed'
}, {
  id: 'seed-004',
  name: 'Metro Fabric Supply',
  email: 'payables@metrofabric.com',
  paymentTerms: 'Net 45',
  inviteSent: true,
  status: 'pending',
  lastActivity: '2025-01-13',
  fundingActivity: 'No funding yet',
  source: 'seed'
}, {
  id: 'seed-005',
  name: 'Coastal Textiles Group',
  email: 'finance@coastaltextiles.com',
  paymentTerms: 'Net 60',
  inviteSent: true,
  status: 'pending',
  lastActivity: '2025-01-12',
  fundingActivity: 'No funding yet',
  source: 'seed'
}, {
  id: 'seed-006',
  name: 'Riverside Manufacturing Co',
  email: 'ap@riversidemanufacturing.com',
  paymentTerms: 'Net 30',
  inviteSent: true,
  status: 'invited',
  lastActivity: '2025-01-11',
  fundingActivity: '—',
  source: 'seed'
}, {
  id: 'seed-007',
  name: 'Northern Logistics Partners',
  email: 'billing@northernlogistics.com',
  paymentTerms: 'Net 45',
  inviteSent: true,
  status: 'invited',
  lastActivity: '2025-01-10',
  fundingActivity: '—',
  source: 'seed'
}, {
  id: 'seed-008',
  name: 'Eastern Supply Chain Co',
  email: 'ap@easternsupply.com',
  paymentTerms: 'Net 60',
  inviteSent: true,
  status: 'invited',
  lastActivity: '2025-01-09',
  fundingActivity: '—',
  source: 'seed'
}, {
  id: 'seed-009',
  name: 'Western Materials Group',
  email: 'accounts@westernmaterials.com',
  paymentTerms: 'Net 30',
  inviteSent: true,
  status: 'invited',
  lastActivity: '2025-01-08',
  fundingActivity: '—',
  source: 'seed'
}, {
  id: 'seed-010',
  name: 'Southern Wholesale Inc',
  email: 'finance@southernwholesale.com',
  paymentTerms: 'Net 45',
  inviteSent: true,
  status: 'invited',
  lastActivity: '2025-01-07',
  fundingActivity: '—',
  source: 'seed'
}, {
  id: 'seed-011',
  name: 'Central Trading Partners',
  email: 'payables@centraltrading.com',
  paymentTerms: 'Net 60',
  inviteSent: true,
  status: 'invited',
  lastActivity: '2025-01-06',
  fundingActivity: '—',
  source: 'seed'
}, {
  id: 'seed-012',
  name: 'Pacific Distribution LLC',
  email: 'billing@pacificdist.com',
  paymentTerms: 'Net 30',
  inviteSent: true,
  status: 'invited',
  lastActivity: '2025-01-05',
  fundingActivity: '—',
  source: 'seed'
}];
// CSV suppliers - different from seeded ones
const CSV_SUPPLIERS: Supplier[] = [{
  id: 'csv-001',
  name: 'Apex Materials Corp',
  email: 'billing@apexmaterials.com',
  paymentTerms: 'Net 45',
  inviteSent: false,
  status: 'invited',
  lastActivity: '—',
  fundingActivity: '—',
  source: 'csv'
}, {
  id: 'csv-002',
  name: 'Delta Supply Chain Solutions',
  email: 'accounts@deltasupply.com',
  paymentTerms: 'Net 60',
  inviteSent: false,
  status: 'invited',
  lastActivity: '—',
  fundingActivity: '—',
  source: 'csv'
}, {
  id: 'csv-003',
  name: 'Horizon Trading Partners',
  email: 'ap@horizontrading.com',
  paymentTerms: 'Net 30',
  inviteSent: false,
  status: 'invited',
  lastActivity: '—',
  fundingActivity: '—',
  source: 'csv'
}];
// ERP suppliers - different from both seeded and CSV
const ERP_SUPPLIERS: Supplier[] = [{
  id: 'erp-001',
  name: 'Pacific Home Goods',
  email: 'payables@pacifichome.com',
  paymentTerms: 'Net 45',
  inviteSent: false,
  status: 'invited',
  lastActivity: '—',
  fundingActivity: '—',
  source: 'erp'
}, {
  id: 'erp-002',
  name: 'Summit Office Supply',
  email: 'finance@summitoffice.com',
  paymentTerms: 'Net 60',
  inviteSent: false,
  status: 'invited',
  lastActivity: '—',
  fundingActivity: '—',
  source: 'erp'
}, {
  id: 'erp-003',
  name: 'Omega Electronics Trading',
  email: 'ap@omegaelectronics.com',
  paymentTerms: 'Net 30',
  inviteSent: false,
  status: 'invited',
  lastActivity: '—',
  fundingActivity: '—',
  source: 'erp'
}];
export function AnchorPortal() {
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [suppliers, setSuppliers] = useState<Supplier[]>([]);
  const [activatedSuppliers, setActivatedSuppliers] = useState<Supplier[]>(SEEDED_ACTIVATED_SUPPLIERS);
  const [selectedSuppliers, setSelectedSuppliers] = useState<Set<string>>(new Set());
  const [showInviteSuccess, setShowInviteSuccess] = useState(false);
  const [showErpModal, setShowErpModal] = useState(false);
  const [csvSynced, setCsvSynced] = useState(false);
  const [erpSynced, setErpSynced] = useState(false);
  const [lastUploadTime, setLastUploadTime] = useState<string>('');
  const fileInputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    document.title = 'Mint | Treasury';
  }, []);
  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setUploadedFile(file);
      setCsvSynced(true);
      const now = new Date();
      const timeStr = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
      setLastUploadTime(timeStr);
      setTimeout(() => {
        setSuppliers(prev => [...prev, ...CSV_SUPPLIERS]);
      }, 500);
    }
  };
  const handleErpSync = (system: string) => {
    setShowErpModal(false);
    setErpSynced(true);
    setTimeout(() => {
      setSuppliers(prev => [...prev, ...ERP_SUPPLIERS]);
      setShowInviteSuccess(true);
      setTimeout(() => setShowInviteSuccess(false), 3000);
    }, 500);
  };
  const handleClearImported = () => {
    setSuppliers([]);
    setUploadedFile(null);
    setCsvSynced(false);
    setErpSynced(false);
    setLastUploadTime('');
    setSelectedSuppliers(new Set());
  };
  const handleSelectAll = () => {
    if (selectedSuppliers.size === suppliers.length) {
      setSelectedSuppliers(new Set());
    } else {
      setSelectedSuppliers(new Set(suppliers.map(s => s.id)));
    }
  };
  const handleSelectSupplier = (id: string) => {
    const newSelected = new Set(selectedSuppliers);
    if (newSelected.has(id)) {
      newSelected.delete(id);
    } else {
      newSelected.add(id);
    }
    setSelectedSuppliers(newSelected);
  };
  const handleInviteSuppliers = () => {
    const invitedSuppliers = suppliers.filter(s => selectedSuppliers.has(s.id));
    const now = new Date().toISOString().split('T')[0];
    const newActivated = invitedSuppliers.map(supplier => ({
      ...supplier,
      inviteSent: true,
      status: 'invited' as const,
      lastActivity: now
    }));
    setActivatedSuppliers(prev => [...prev, ...newActivated]);
    setSuppliers(prev => prev.filter(s => !selectedSuppliers.has(s.id)));
    setSelectedSuppliers(new Set());
    setShowInviteSuccess(true);
    setTimeout(() => setShowInviteSuccess(false), 3000);
  };
  const getStatusBadge = (status: string) => {
    const styles = {
      invited: 'bg-blue-50 text-blue-700',
      pending: 'bg-yellow-50 text-yellow-700',
      active: 'bg-green-50 text-green-700'
    };
    return styles[status as keyof typeof styles] || styles.invited;
  };
  const invitedCount = activatedSuppliers.length;
  const pendingCount = activatedSuppliers.filter(s => s.status === 'pending').length;
  const activeCount = activatedSuppliers.filter(s => s.status === 'active').length;
  const csvSupplierCount = suppliers.filter(s => s.source === 'csv').length;
  const erpSupplierCount = suppliers.filter(s => s.source === 'erp').length;
  return <div className="min-h-screen bg-gray-50" data-id="element-525">
      <div className="max-w-7xl mx-auto" data-id="element-526">
        {/* Header */}
        <div className="mb-8" data-id="element-527">
          <h1 className="text-3xl font-semibold text-gray-900" data-id="element-528">Treasury</h1>
          <p className="text-gray-600 mt-1" data-id="element-529">Supplier Activation</p>
        </div>
        {/* Success Toast */}
        {showInviteSuccess && <div className="mb-6 bg-green-50 border border-green-200 rounded-lg p-4 flex items-center justify-between" data-id="element-530">
            <div className="flex items-center" data-id="element-531">
              <CheckCircleIcon size={20} className="text-green-600 mr-3" data-id="element-532" />
              <span className="text-sm text-green-800" data-id="element-533">
                Invitations sent successfully
              </span>
            </div>
            <button onClick={() => setShowInviteSuccess(false)} className="text-green-600 hover:text-green-700" data-id="element-534">
              <XIcon size={16} data-id="element-535" />
            </button>
          </div>}
        {/* Top Section: Activation Status + AI Intelligence */}
        <div className="grid grid-cols-3 gap-6 mb-8" data-id="element-536">
          {/* Left: Supplier Activation Status */}
          <div className="col-span-2 bg-white rounded-lg border border-gray-200" data-id="element-537">
            <div className="p-6 border-b border-gray-200" data-id="element-538">
              <div className="flex items-center justify-between mb-6" data-id="element-539">
                <div data-id="element-540">
                  <h2 className="text-lg font-medium text-gray-900" data-id="element-541">
                    Supplier Activation Status
                  </h2>
                </div>
                <button className="inline-flex items-center px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm" data-id="element-542">
                  <DownloadIcon size={16} className="mr-2" data-id="element-543" />
                  Export
                </button>
              </div>
              {/* Summary Cards */}
              <div className="grid grid-cols-3 gap-4" data-id="element-544">
                <div className="bg-gray-50 rounded-lg p-4" data-id="element-545">
                  <div className="flex items-center justify-between" data-id="element-546">
                    <div data-id="element-547">
                      <div className="text-xs text-gray-500 uppercase tracking-wide mb-1" data-id="element-548">
                        Suppliers Invited
                      </div>
                      <div className="text-2xl font-semibold text-gray-900" data-id="element-549">
                        {invitedCount}
                      </div>
                    </div>
                    <UsersIcon size={24} className="text-gray-400" data-id="element-550" />
                  </div>
                </div>
                <div className="bg-gray-50 rounded-lg p-4" data-id="element-551">
                  <div className="flex items-center justify-between" data-id="element-552">
                    <div data-id="element-553">
                      <div className="text-xs text-gray-500 uppercase tracking-wide mb-1" data-id="element-554">
                        Pending Activation
                      </div>
                      <div className="text-2xl font-semibold text-gray-900" data-id="element-555">
                        {pendingCount}
                      </div>
                    </div>
                    <ClockIcon size={24} className="text-gray-400" data-id="element-556" />
                  </div>
                </div>
                <div className="bg-gray-50 rounded-lg p-4" data-id="element-557">
                  <div className="flex items-center justify-between" data-id="element-558">
                    <div data-id="element-559">
                      <div className="text-xs text-gray-500 uppercase tracking-wide mb-1" data-id="element-560">
                        Active Suppliers
                      </div>
                      <div className="text-2xl font-semibold text-gray-900" data-id="element-561">
                        {activeCount}
                      </div>
                    </div>
                    <UserCheckIcon size={24} className="text-gray-400" data-id="element-562" />
                  </div>
                </div>
              </div>
            </div>
            {/* Activation Table */}
            <div className="overflow-x-auto" data-id="element-563">
              <table className="min-w-full divide-y divide-gray-200" data-id="element-564">
                <thead className="bg-gray-50" data-id="element-565">
                  <tr data-id="element-566">
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-567">
                      Supplier Name
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-568">
                      Invite Sent
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-569">
                      Status
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-570">
                      Funding Activity
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-571">
                      Last Activity
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-572">
                  {activatedSuppliers.map(supplier => <tr key={supplier.id} className="hover:bg-gray-50" data-id="element-573">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-574">
                        {supplier.name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-575">
                        <div className="flex items-center text-sm text-gray-600" data-id="element-576">
                          <CheckCircleIcon size={16} className="text-green-600 mr-2" data-id="element-577" />
                          Yes
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-578">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusBadge(supplier.status)}`} data-id="element-579">
                          {supplier.status === 'invited' && <MailIcon size={12} className="mr-1" data-id="element-580" />}
                          {supplier.status === 'pending' && <ClockIcon size={12} className="mr-1" data-id="element-581" />}
                          {supplier.status === 'active' && <CheckCircleIcon size={12} className="mr-1" data-id="element-582" />}
                          {supplier.status.charAt(0).toUpperCase() + supplier.status.slice(1)}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-583">
                        {supplier.fundingActivity}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-584">
                        {supplier.lastActivity}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
          {/* Right: Mint Intelligence Overview */}
          <div className="space-y-4" data-id="element-585">
            <div className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-2" data-id="element-586">
              Mint Intelligence Overview
            </div>
            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-587">
              <div className="flex items-start justify-between mb-3" data-id="element-588">
                <div data-id="element-589">
                  <div className="text-xs text-gray-500 uppercase tracking-wide mb-1" data-id="element-590">
                    Invoices Validated
                  </div>
                  <div className="text-2xl font-semibold text-gray-900" data-id="element-591">
                    100%
                  </div>
                </div>
                <ShieldCheckIcon size={20} className="text-green-600" data-id="element-592" />
              </div>
            </div>
            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-593">
              <div className="flex items-start justify-between mb-3" data-id="element-594">
                <div data-id="element-595">
                  <div className="text-xs text-gray-500 uppercase tracking-wide mb-1" data-id="element-596">
                    Buyer Legitimacy
                  </div>
                  <div className="text-2xl font-semibold text-gray-900" data-id="element-597">
                    Stable
                  </div>
                </div>
                <CheckCircleIcon size={20} className="text-green-600" data-id="element-598" />
              </div>
            </div>
            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-599">
              <div className="flex items-start justify-between mb-3" data-id="element-600">
                <div data-id="element-601">
                  <div className="text-xs text-gray-500 uppercase tracking-wide mb-1" data-id="element-602">
                    Authenticity Score
                  </div>
                  <div className="text-2xl font-semibold text-gray-900" data-id="element-603">
                    99.3%
                  </div>
                </div>
                <TrendingUpIcon size={20} className="text-green-600" data-id="element-604" />
              </div>
            </div>
            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-605">
              <div className="flex items-start justify-between mb-3" data-id="element-606">
                <div data-id="element-607">
                  <div className="text-xs text-gray-500 uppercase tracking-wide mb-1" data-id="element-608">
                    Anomalies Detected
                  </div>
                  <div className="text-2xl font-semibold text-gray-900" data-id="element-609">0</div>
                </div>
                <AlertCircleIcon size={20} className="text-gray-400" data-id="element-610" />
              </div>
            </div>
          </div>
        </div>
        {/* Middle: Invite Suppliers Section */}
        <div className="bg-white rounded-lg border border-gray-200 mb-8" data-id="element-611">
          <div className="p-6 border-b border-gray-200" data-id="element-612">
            <div className="flex items-center justify-between" data-id="element-613">
              <div data-id="element-614">
                <h2 className="text-lg font-medium text-gray-900" data-id="element-615">
                  Invite Suppliers
                </h2>
              </div>
              <div className="flex items-center gap-3" data-id="element-616">
                {suppliers.length > 0 && <button onClick={handleClearImported} className="text-sm text-gray-600 hover:text-gray-800 font-medium" data-id="element-617">
                    Clear imported list
                  </button>}
                {selectedSuppliers.size > 0 && <button onClick={handleInviteSuppliers} className="inline-flex items-center px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors text-sm" data-id="element-618">
                    <MailIcon size={16} className="mr-2" data-id="element-619" />
                    Invite {selectedSuppliers.size} Supplier
                    {selectedSuppliers.size > 1 ? 's' : ''}
                  </button>}
              </div>
            </div>
            {/* Upload Status Banners */}
            {csvSynced && csvSupplierCount > 0 && <div className="mt-4 flex items-center justify-between bg-blue-50 border border-blue-200 rounded-lg px-4 py-2" data-id="element-620">
                <div className="flex items-center text-sm text-blue-800" data-id="element-621">
                  <CheckCircleIcon size={16} className="text-blue-600 mr-2" data-id="element-622" />
                  Uploaded {uploadedFile?.name || 'Book2.csv'} with{' '}
                  {csvSupplierCount} suppliers
                  {lastUploadTime && ` at ${lastUploadTime}`}
                </div>
              </div>}
            {erpSynced && erpSupplierCount > 0 && <div className="mt-4 flex items-center justify-between bg-green-50 border border-green-200 rounded-lg px-4 py-2" data-id="element-623">
                <div className="flex items-center text-sm text-green-800" data-id="element-624">
                  <CheckCircleIcon size={16} className="text-green-600 mr-2" data-id="element-625" />
                  Synced from QuickBooks with {erpSupplierCount} suppliers
                </div>
              </div>}
          </div>
          <div className="overflow-x-auto" data-id="element-626">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-627">
              <thead className="bg-gray-50" data-id="element-628">
                <tr data-id="element-629">
                  <th className="px-6 py-3 text-left" data-id="element-630">
                    <input type="checkbox" checked={suppliers.length > 0 && selectedSuppliers.size === suppliers.length} onChange={handleSelectAll} disabled={suppliers.length === 0} className="rounded border-gray-300 text-gray-800 focus:ring-gray-500 disabled:opacity-50" data-id="element-631" />
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-632">
                    Supplier Name
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-633">
                    Email
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-634">
                    Payment Terms
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-635">
                {suppliers.length === 0 ? <tr data-id="element-636">
                    <td colSpan={4} className="px-6 py-12 text-center text-sm text-gray-500" data-id="element-637">
                      Upload or sync your supplier list to start inviting
                    </td>
                  </tr> : suppliers.map(supplier => <tr key={supplier.id} className="hover:bg-gray-50 transition-colors" data-id="element-638">
                      <td className="px-6 py-4" data-id="element-639">
                        <input type="checkbox" checked={selectedSuppliers.has(supplier.id)} onChange={() => handleSelectSupplier(supplier.id)} className="rounded border-gray-300 text-gray-800 focus:ring-gray-500" data-id="element-640" />
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-641">
                        {supplier.name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-642">
                        {supplier.email}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-643">
                        {supplier.paymentTerms}
                      </td>
                    </tr>)}
              </tbody>
            </table>
          </div>
        </div>
        {/* Bottom: Upload or Sync Section */}
        <div className="bg-white rounded-lg border border-gray-200 p-8" data-id="element-644">
          <div className="max-w-2xl mx-auto" data-id="element-645">
            <div className="mb-6 text-center" data-id="element-646">
              <h2 className="text-lg font-medium text-gray-900 mb-2" data-id="element-647">
                Upload or Sync Supplier List
              </h2>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-648">
              <button onClick={() => fileInputRef.current?.click()} className="inline-flex items-center justify-center px-6 py-3 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors text-sm" data-id="element-649">
                <UploadIcon size={18} className="mr-2" data-id="element-650" />
                Upload CSV
              </button>
              <button onClick={() => setShowErpModal(true)} className="inline-flex items-center justify-center px-6 py-3 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm" data-id="element-651">
                <RefreshCwIcon size={18} className="mr-2" data-id="element-652" />
                Sync from ERP
              </button>
            </div>
            <input ref={fileInputRef} type="file" accept=".csv" onChange={handleFileUpload} className="hidden" data-id="element-653" />
          </div>
        </div>
      </div>
      {/* ERP Sync Modal */}
      {showErpModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-654">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4" data-id="element-655">
            <div className="p-6 border-b border-gray-200" data-id="element-656">
              <div className="flex items-center justify-between" data-id="element-657">
                <h3 className="text-lg font-medium text-gray-900" data-id="element-658">
                  Sync from ERP
                </h3>
                <button onClick={() => setShowErpModal(false)} className="text-gray-400 hover:text-gray-500" data-id="element-659">
                  <XIcon size={20} data-id="element-660" />
                </button>
              </div>
            </div>
            <div className="p-6" data-id="element-661">
              <p className="text-sm text-gray-600 mb-4" data-id="element-662">
                Select your ERP system to sync supplier data
              </p>
              <div className="space-y-2" data-id="element-663">
                <button onClick={() => handleErpSync('QuickBooks')} className="w-full flex items-center justify-between px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors text-left" data-id="element-664">
                  <span className="text-sm font-medium text-gray-900" data-id="element-665">
                    QuickBooks
                  </span>
                  <span className="text-xs text-green-600 font-medium" data-id="element-666">
                    Active
                  </span>
                </button>
                <button disabled className="w-full flex items-center justify-between px-4 py-3 border border-gray-200 rounded-lg bg-gray-50 cursor-not-allowed text-left" data-id="element-667">
                  <span className="text-sm font-medium text-gray-400" data-id="element-668">
                    NetSuite
                  </span>
                  <span className="text-xs text-gray-400" data-id="element-669">Coming soon</span>
                </button>
                <button disabled className="w-full flex items-center justify-between px-4 py-3 border border-gray-200 rounded-lg bg-gray-50 cursor-not-allowed text-left" data-id="element-670">
                  <span className="text-sm font-medium text-gray-400" data-id="element-671">SAP</span>
                  <span className="text-xs text-gray-400" data-id="element-672">Coming soon</span>
                </button>
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex justify-end" data-id="element-673">
              <button onClick={() => setShowErpModal(false)} className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-800" data-id="element-674">
                Cancel
              </button>
            </div>
          </div>
        </div>}
    </div>;
}